export var FieldValueType;
(function (FieldValueType) {
    FieldValueType["NAME"] = "NAME";
    FieldValueType["EMAIL"] = "EMAIL";
    FieldValueType["PHONE"] = "PHONE";
    FieldValueType["ADDRESS"] = "ADDRESS";
    FieldValueType["LABELS"] = "LABELS";
    FieldValueType["ASSIGNEES"] = "ASSIGNEES";
    FieldValueType["COMPANY"] = "COMPANY";
    FieldValueType["POSITION"] = "POSITION";
    FieldValueType["VAT_ID"] = "VAT_ID";
    FieldValueType["BIRTHDAY"] = "BIRTHDAY";
    FieldValueType["WEBSITE"] = "WEBSITE";
    FieldValueType["DATE"] = "DATE";
    FieldValueType["CUSTOM"] = "CUSTOM";
})(FieldValueType || (FieldValueType = {}));
export var FieldActionType;
(function (FieldActionType) {
    FieldActionType["ADD"] = "add";
    FieldActionType["RENAME"] = "rename";
    FieldActionType["REMOVE"] = "remove";
})(FieldActionType || (FieldActionType = {}));
export var FieldActions = {
    ADD: {
        name: FieldActionType.ADD,
        onlyInList: false,
    },
    RENAME: {
        name: FieldActionType.RENAME,
        onlyInList: true,
    },
    REMOVE: {
        name: FieldActionType.REMOVE,
        onlyInList: true,
    },
};
//# sourceMappingURL=Fields.js.map